//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
import Moment from 'moment';
import config from '../../config';
//-- Custom
import { withStyles } from "@material-ui/core/styles";
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { trendingActions, alertActions, userActions } from '../../_actions';
import { apiConstants } from '../../_constants/api.constants';
import Pagination from "../Common/Pagination/Pagination";
import PageLimit from "../Common/PageLimit/PageLimit";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';


const styles = theme => ({
    error: {
        color: 'red',
    },
    root: {
        margin: 0,
        padding: theme.spacing(2),
        backgroundColor: "#269abc",
        color: '#fff'
    },
    contentRoot: {
        padding: theme.spacing(2),
        fontSize: 14,
        width: 600
    },
    actionRoot: {
        margin: 0,
        padding: theme.spacing(1)
    }
});


class Trending extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            perPageData: 10,
            getTrendingList: [],
            deleteOpen: false,
            tags: {
                name: '',
            },
        };
    }

    /*
    * componentDidMount - Initially it will call and get the tags data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPageData;

        dispatch(trendingActions.getTrendingList(apiConstants.GET_TRENDING_LIST, postData));
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {
        const { siteConstants } = props.language;
        const { dispatch } = this.props;

        if (this.props.deleteTrending.deleteTrending !== undefined && this.props.deleteTrending.deleteTrending !== false) {
            if (this.state.triggerDelete === true) {
                dispatch(alertActions.success(siteConstants.GEN_TAG_DELETED_NOTIFICATION));
                this.setState({ enableDelete: false, deleteTrendingId: '', triggerDelete: false });
                setTimeout(function () {
                    dispatch(alertActions.clear());
                }, 3000);

            }
        }

        if (props.getTrendingList) {
            if (props.getTrendingList.getTrendingList) {
                if (props.getTrendingList.getTrendingList.data && props.getTrendingList.getTrendingList.pagination !== undefined) {
                    this.setState({
                        totalPage: props.getTrendingList.getTrendingList.pagination.totalPages,
                        totalDataCount: props.getTrendingList.getTrendingList.pagination.totalCount,
                        getTrendingList: props.getTrendingList.getTrendingList.data,
                        currentPage: props.getTrendingList.getTrendingList.pagination.currentPage,
                    })
                }
            }
        }
    }

    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });

        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPageData;

        dispatch(trendingActions.getTrendingList(apiConstants.GET_TRENDING_LIST, postData));
    }

    // /*
    // * searchTrending - User can search data from the database and it will appear
    // */
    // searchTrending(keyword) {
    //     const { dispatch } = this.props;
    //     let postData = {};
    //     postData.page = 1;
    //     postData.orderBy = "id";
    //     postData.orderByAscDesc = "ASC";
    //     postData.perPage = this.state.perPageData;

    //     if (this.state.perPageData !== 10)
    //         this.setState({ perPageData: 10 });

    //     if (keyword.target.value !== '') {
    //         postData.qwery = keyword.target.value;
    //         dispatch(trendingActions.getTrendingList(apiConstants.GET_TRENDING_LIST, postData));
    //     } else {
    //         dispatch(trendingActions.getTrendingList(apiConstants.GET_TRENDING_LIST, postData));
    //     }



    // }


    /*
    *   Page Limit handle
    */
    handlePageLimitChange = (e) => {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPageData = parseInt(e.target.value);

        this.setState({ perPageData: parseInt(e.target.value) });
        dispatch(userActions.getTrendingList(apiConstants.GET_TRENDING_LIST, postData));
    }

    /*
    *   We are handling validation from this function
    */
    handleValidation(data) {
        const { siteConstants } = this.props.language;
        let fields = data.defaultData;
        let errors = {};
        let formIsValid = true;
        //Name
        if ((fields["name"] == '')) {
            formIsValid = false;
            if (fields["name"] == '')
                errors["name"] = siteConstants.ERR_CAN_NOT_BLANK;
        }

        return ({ errors, formIsValid });
    }

    /*
        we can remove the selected data, using the below function
    */
    deleteTrendingNow = () => {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = this.state.currentPage;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = this.state.perPageData;

        this.setState({
            triggerDelete: true
        })

        let obj = {};
        obj.id = this.state.deleteTrendingId;
        this.props.dispatch(trendingActions.deleteTrending(apiConstants.DELETE_TRENDING, obj, apiConstants.GET_TRENDING_LIST, postData));
    }

    // delete a tag by tagId
    deleteTrending = (tagId) => {
        this.setState({
            enableDelete: true,
            deleteTrendingId: tagId
        })
    }

    closeDeletePopup = () => {
        this.setState({
            enableDelete: false,
            deleteTrendingId: ''
        })
    }


    //-- Main function
    render() {

        const { siteConstants } = this.props.language;
        const { classes } = this.props;
        return (
            <div id="wrapper">
                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_TAGS}
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                <h1 className="h3 mb-0 text-gray-800">Trending</h1>
                            </div>

                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="row">
                                            {/* Page limit drop down */}
                                            <PageLimit changeLimit={(e) => this.handlePageLimitChange(e)} perPageData={this.state.perPageData} />

                                            {/* <div className="col-sm-12 col-md-6">
                                                <div id="dataTable_filter" className="dataTables_filter">
                                                    <label>
                                                        <input type="search" palaceholder={siteConstants.GEN_SEARCH} className="form-control form-control-sm" placeholder="" aria-controls="dataTable" onChange={(e) => this.searchTrending(e)} />
                                                    </label>
                                                </div>
                                            </div> */}
                                        </div>
                                        <table className="table table-bordered" width="100%" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" width="10%">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="col">Product Name</th>
                                                    <th width="10%">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.getTrendingList != undefined && this.state.getTrendingList.length > 0 ? this.state.getTrendingList.map((trending, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td scope="row">{index + 1}</td>
                                                                <td>{trending.product_id.title}</td>
                                                                <td className="tdTextCenter">
                                                                    <a className="actionIcon" title="Delete" href="javascript:void(0)" onClick={() => this.deleteTrending(trending._id)}><span><img src="assets/img/svg/Bin.png" alt="Delete" /></span></a>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }) : <tr>
                                                        <td colSpan="3">{siteConstants.GEN_NO_RECORD}</td>
                                                    </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* calling the another componenet */}
                                    <Pagination totalPage={this.state.totalPage} currentPage={this.state.currentPage} funPagination={this.makeHttpRequestWithPage} />



                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    <Footer />
                </div>

                
                {/* notify about delete */}
                <Dialog open={this.state.enableDelete} aria-labelledby="delete-tag-notify" >
                    <DialogTitle className={classes.root}>
                        {siteConstants.BTN_DELETE}
                    </DialogTitle>
                    <DialogContent>
                        {siteConstants.GEN_ARE_SURE_TO_DELETE_TAG}
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="primary" onClick={(e) => this.deleteTrendingNow(e)}>{siteConstants.GEN_DELETE_THIS}</Button>
                        <Button variant="contained" onClick={() => this.closeDeletePopup(0)}>{siteConstants.LABEL_CANCEL}</Button>
                    </DialogActions>
                </Dialog>

            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { getTrendingList, language, deleteTrending } = state;
    return {
        getTrendingList,
        language,
        deleteTrending
    };
}

export default connect(mapStateToProps)(withStyles(styles)(Trending));
